<div class="voice-command-container">
  <div class="voice-controls">
    <button mat-fab 
            [class.processing]="isProcessing"
            (click)="openVoiceDialog()"
            [disabled]="!speechSupported || isProcessing || disabled"
            matTooltip="Open voice command dialog">
      <mat-icon>{{ getButtonIcon() }}</mat-icon>
    </button>
  </div>
  
  <div *ngIf="!speechSupported" class="fallback-notice">
    <mat-chip color="warn">
      <mat-icon>warning</mat-icon>
      Voice not supported - use text input
    </mat-chip>
  </div>
</div>